import { useState } from 'react';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import Modal from '@components/global/Modal';
import {
  SizeChartInterface,
  SizeFitRiseInterface,
} from '@adapters/bigcommerce/types/sizeChart';
import { usePdp } from '@context/PdpContext';
import SimpleButton from '_components/UI/SimpleButton';
import { trackSizeGuide } from '@utils/gtm/ga4/trackSizeGuide';

import measureStyles from '@components/product/ProductMeasure/Measure.module.scss';

const FindMySizeModal = dynamic(() => import('../FindMySizeModal'), {
  loading: () => null,
});

export interface FindMySizeProps {
  measure: SizeChartInterface;
  sizeDetail: SizeFitRiseInterface;
  isBike: boolean;
}

const FindMySize = ({ measure, sizeDetail, isBike }: FindMySizeProps) => {
  const { t } = useTranslation('productMeasure');
  const { brand } = usePdp();
  const [isOpen, setIsOpen] = useState(false);
  const closeModal = () => setIsOpen(false);

  if (!sizeDetail) return null;

  const handleClick = () => {
    trackSizeGuide({ linkText: t('size.guide') });
    setIsOpen(true);
  };

  return (
    <>
      <SimpleButton variant="secondary" size="small" onClick={handleClick}>
        {t('size.guide')}
      </SimpleButton>
      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        label={t('findMySize.title')}
        classNames={measureStyles.findMySizeModal}
        fitContent
        bottomPositioning
        closeButtonVisible={false}
      >
        <FindMySizeModal
          measure={measure}
          sizeDetail={sizeDetail}
          isBike={isBike}
          brandName={brand}
          onClose={closeModal}
        />
      </Modal>
    </>
  );
};

export default FindMySize;
